import { WaysOfRegister } from '@/shared/composables/useRegisterData';
import {
  Timezone, UserStatus, UserToRoleStatus, UserType,
} from '@/core/graphql/types';
import { ID, MaybeNull } from '@/shared/types';
import { defineStore } from 'pinia';
import {
  onMounted,
  ref,
  Ref,
} from 'vue';

export interface User {
  // id: ID,
  // name: string,
  // email: string,
  waysOfRegister?: WaysOfRegister,
  // registrationDate: string,

  id: ID,
  type: UserType,
  status: UserStatus,
  lastName: string,
  fullName: string,
  firstName: string,
  email: string,
  phoneNumber?: MaybeNull<string>,
  avatarUrl?: MaybeNull<string>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolvedPermissions: any[],
  permissions: string[],
  createdAt: string,
  lastSeen: string,
  timezone?: MaybeNull<Timezone>,
  fcmToken?: MaybeNull<string>,
  completedOnboarding?: boolean,
  userToRoles: {
    id: ID,
    status: UserToRoleStatus,
    role: {
      permissions: string[],
      title: string,
      id: ID,
      description?: MaybeNull<string>,
      organizationId?: MaybeNull<string>,
    }
  }[]
}

// interface UpdateRegisterWayInput {
//   way: RegistrationWaysIds,
//   data: WayOfRegister,
// }

export const useUserStore = defineStore('userStore', () => {
  const user: Ref<MaybeNull<User>> = ref(null);

  const getUser = () => {
    if (localStorage.getItem('user')) {
      user.value = JSON.parse(localStorage.getItem('user') || '');
    }
  };

  const setUser = (data: User) => {
    user.value = data;

    localStorage.setItem('user', JSON.stringify(user.value));
  };

  const getUserOrFail = (): Ref<User> => {
    if (!user.value) {
      throw new Error('Unable to get user. User is not defined');
    }

    return user as Ref<User>;
  };

  onMounted(() => {
    getUser();
  });

  return {
    user,
    getUser,
    setUser,
    getUserOrFail,
  };
});
